import Profile from "./profile";

const Parents = {
  Profile: Profile
};

export default Parents;
